/**
 * Production-safe challenge send error messages (no emulator/dev copy).
 */
export function getChallengeSendErrorMessage(err, { isCustom = false } = {}) {
  const code = err?.code || '';

  if (err?.message === 'NOT_FRIENDS') {
    return 'Challenge not sent — you must be friends with this player. Send and accept a friend request, then try again.';
  }
  if (err?.message === 'WAGER_BLOCKED') {
    return 'Challenge not sent — messaging and challenges are blocked for this player.';
  }
  if (code === 'permission-denied') {
    if (isCustom) {
      return 'Challenge not sent — custom challenges require LockedIn Plus. Confirm your membership in Wallet, then try again.';
    }
    return 'Challenge not sent — please confirm you\'re signed in and allowed to send this challenge.';
  }
  return err?.message || 'Could not send challenge. Try again.';
}

export function getOpenChallengePostErrorMessage(err) {
  const code = err?.code || '';
  if (code === 'permission-denied') {
    return 'Could not post — Open Arena and group locks require LockedIn Plus. Confirm your membership in Wallet, then try again.';
  }
  return err?.message || 'Could not post challenge. Try again.';
}
